import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function updateUserAPI(userId, userData) {
  const url = `${AWS_API_URL}/admin/users/${userId}`;

  return putRequest(url, { data: userData }, await authorize());
}
